<!--
 * @Description: 资产报修
 * @Author: PF
 * @Date: 2023-12-11 16:50:24
 * @LastEditors: PF
 * @LastEditTime: 2024-07-10 15:56:45
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">资产报修</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="地点" prop="dd" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="处理状态" prop="clzt.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="维修人员" prop="wxryxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="维修时间" prop="wxsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="维修结果" prop="wxjg" align="center" show-overflow-tooltip />
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="180" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" v-if="clztData.weiChuLi === scope.row.clzt.value" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" v-if="clztData.weiChuLi === scope.row.clzt.value"  @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  homeCloseWindow,
  submitDataGridAction,
  loadSelect
} from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'wxsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/houqin/baoxiu/chaxunwodebaoxiu',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openList = ref(false)
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)

const clztData = ref({ list: [] }) // 处理状态
watch(
  () => props.open,
  () => {
    if (props.open === 'zichanbaoxiu') {
      openList.value = true
      loadSelect({ url: '/api/v2/houqin/baoxiu/chulizhuangtai', data: clztData })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/houqin/baoxiu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
</script>
